<template>
  <div class="tab">
    <div class="tab-ul">
      <ul>
        <li
          v-for="item in tabData"
          :key="item.path"
          :class="item.path === activeProduct ? 'active' : ''"
        >
          <router-link :to="item.path">{{ item.name }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabData: [
        {
          path: '/mobile/interestRate/rmbcxckll',
          name: '人民币储蓄存款利率',
        },
        {
          path: '/mobile/interestRate/rmbdwckllcx',
          name: '人民币单位存款利率查询',
        },
        {
          path: '/mobile/interestRate/xewbckllcx',
          name: '小额外币存款查询',
        },
        {
          path: '/mobile/interestRate/rmbdkll',
          name: '人民币贷款市场利率（LPR）',
        },
      ],
    }
  },
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped>
// .menuContainer [role='menubar'] {
//   width: 320px;
// }
// .el-menu-item {
//   a {
//     color: inherit;
//     text-decoration: none;
//   }
// }
.tab {
  margin: 16px 0;
  padding: 16px;
  background: #fff;
}
.tab-ul {
  overflow: hidden;
  ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // gap: 16px;
    // -webkit-gap: 16px;
    margin-bottom: -16px;
    margin-right: -16px;
    li {
      color: #333;
      background: #f5f5f5;
      border: 1px solid #f5f5f5;
      padding: 0 10px;
      line-height: 28px;
      font-size: 14px;
      margin-bottom: 16px;
      margin-right: 16px;
    }
    .active {
      color: #ff3333;
      background: #ffebeb;
      border: 1px solid #ee6723;
    }
  }
}
</style>
